import { useEffect, useState, useCallback } from 'react';
import {
  isFullscreen, toggleFullscreen, onFullscreenChange,
  fullscreenAvailable, fullscreenUseful, isIOS,
} from '../lib/fullscreen';
import { alertDialog } from '../lib/swal';
import { useT } from '../i18n';

export function useFullscreen(): { isFs: boolean; toggle: () => void; available: boolean } {
  const t = useT();
  const [isFs, setIsFs] = useState<boolean>(() => isFullscreen());
  useEffect(() => onFullscreenChange(() => setIsFs(isFullscreen())), []);
  const toggle = useCallback(() => {
    if (fullscreenAvailable()) {
      toggleFullscreen().catch(() => {});
      return;
    }
    if (isIOS()) {
      alertDialog({
        title: t('fullscreen.iosTitle'),
        text: t('fullscreen.iosHint'),
        icon: 'info',
      });
    }
  }, [t]);
  return { isFs, toggle, available: fullscreenUseful() };
}
